export default __webpack_public_path__ + "static/media/ΔΕΠΑ.7db74bd4.png";